<template>
  <a-modal :getContainer="getContainer" v-model:visible="visible" :title="title" @cancel="close" :keyboard="false"
           :maskClosable="true" :footer="null" :afterClose="afterClose">
    <a-spin :spinning="spinning">
      <a-form ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="ICD编码" name="icdCode">
          <a-input v-model:value="form.icdCode" disabled/>
        </a-form-item>
        <a-form-item label="ICD名称" name="icdName">
          <a-input v-model:value="form.icdName" disabled/>
        </a-form-item>
        <a-form-item label="核保类别" name="accidentReason">
          <a-select v-model:value="form.underwritingCategory" placeholder="请选择">
            <a-select-option value="1">一类</a-select-option>
            <a-select-option value="2">二类</a-select-option>
            <a-select-option value="3">三类</a-select-option>
            <a-select-option value="4">四类</a-select-option>
            <a-select-option value="5">五类</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <div class="form-bootom-button">
        <a-button type="button" @click="close">取消</a-button>
        <a-button type="primary" @click="save" style="margin-left: 10px">确定</a-button>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import api from '@/api';
import CommonMixin from "@/mixin/CommonMixin";

export default {
  name: 'UnderwritingCategoryModal',
  mixins: [CommonMixin],
  data() {
    return {
      visible: false,
      spinning: false,
      title: '',
      form: {},
      diseaseTypeList: [],
      rules: {
        roleName: [
          {required: true, message: '请输入角色名称！', trigger: 'blur'},
        ]
      },
    }
  },
  methods: {
    getContainer() {
      return document.getElementById("comptainer_underwriting_category");
    },
    close() {
      this.visible = false;
    },
    afterClose() {
      this.$refs.form.clearValidate();
      Object.assign(this.$data, this.$options.data.call(this));
    },
    edit(record) {
      this.visible = true;
      this.title = '核保类别配置';
      this.form = record;
    },
    okCallback() {
      this.$emit('ok');
    },
    formData() {
      return this.form;
    },
    save() {
      let that = this;
      that.$refs.form.validate().then(() => {
        that.spinning = true;
        api.saveunderwritingCategory(that.formData()).then(res => {
          that.spinning = false;
          if (res.code != that.apiStatus.success) {
            that.$message.error(res.message);
            return;
          }
          that.$message.success(that.apiStatus.defaultSuccMsg);
          that.close();
          that.okCallback();
        }).catch(() => {
          that.spinning = false;
          that.$message.error(that.apiStatus.defaultErrMsg);
        });
      });
    }
  }
}
</script>
